
export class PartyCount {
  public partyId = '';
  public partyName = '';
  public colourCode = '';
  public firstPrefVotes = 0;
  public firstPrefShare = 0;
  public firstPrefPreviousCount = 0;
  public totalPeviousCount = 0;
  public totalSeats = 1;
  public leadingDistrictSeatCount = 0;
  public winningPreviousSeatCount = 0;
  public leadingDistricts = '';
  public totalLeadingSeatCount = 0;

  public get seatChange(): number {
    return ((this.leadingDistrictSeatCount - this.winningPreviousSeatCount) / this.totalSeats) * 100;
  }

  public get firstPrefChange(): number | null {
    if (this.firstPrefPreviousCount === null || this.totalPeviousCount === null || this.totalPeviousCount === 0) {
      return null;
    }
    return this.firstPrefShare - (this.firstPrefPreviousCount / this.totalPeviousCount) * 100;
  }

  public get leadingDistrictSeatCountShare(): number | null {
    if (this.totalLeadingSeatCount === 0) {
      return null;
    }
    return (this.leadingDistrictSeatCount / this.totalLeadingSeatCount) * 100;
  }

  public get leadingDistrictSeatCountChange(): number | null {
    if (this.winningPreviousSeatCount === 0 || this.leadingDistrictSeatCountShare === null) {
      return null;
    }
    return this.leadingDistrictSeatCountShare - (this.winningPreviousSeatCount / this.totalSeats) * 100;
  }

}
